export default __webpack_public_path__ + "static/media/sabay_icon.6a145055.svg";